import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography, makeStyles, TextField, Button, CircularProgress as Loading } from '@material-ui/core';

import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'

import * as actions from '../../../../../store/actions/index'
import { connect } from 'react-redux';
// import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  row: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  formRoot: {
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 4, 3)
  }
}));

const schema = yup.object().shape({
  // status: yup.string().required(),
  // description: yup.string().required()
});

const AddTypeAsset = props => {
  const classes = useStyles();
  const { onStoreTypeAsset, loading, error, token, onClearErrorTypeAsset } = props;

  useEffect(() => {
    onClearErrorTypeAsset()
  },[onClearErrorTypeAsset])

  const { register, handleSubmit } = useForm({
    resolver: yupResolver(schema)
  })
  
  const onSubmit = data => {
    // console.log(data);
    onStoreTypeAsset(data, token);
    // console.log(data);
  }
  
  const handleChange = (event) => {
    const target = event.target.name
    event.persist()
    
    if(event.target.type === 'checkbox'){
      setFormState((formState) => ({
        ...formState,
        [target]: {
          value: event.target.checked
        }
      }))
    }else{
      setFormState((formState) => ({
        ...formState,
        [target]: {
          value: event.target.value
        }
      }))
    }
  }
  
  const [formState, setFormState] = useState({
    name: ''
  });

  let button = (loading ? <Loading /> : (
    <Button type="submit" variant="contained" style={{ backgroundColor: '#FF9300', color: '#FFFFFF' }} fullWidth disableElevation>
      Simpan
    </Button>
  ))

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Paper className={classes.formRoot}>
            <Typography>Jenis Aset</Typography>
            <div className={classes.row}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    label="Nama Jenis Aset"
                    variant="outlined"
                    name="name"
                    fullWidth
                    inputRef={register}
                    error={error.name ? true : false}
                    helperText={error.name && error.name[0]}

                    defaultValue={formState.name}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </div>
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item lg={8} md={8} sm={8} xs={8} />
        <Grid item lg={4} md={4} sm={4} xs={4} >
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={6} xs={6}>
                  <Button variant="contained" fullWidth disableElevation onClick={props.closedModalDialog}>
                    Batal
                  </Button>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6}>
                  {button}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        
      </Grid>
    </form>
  )
}

const mapStateToProps = state => {
  return {
    loading: state.typeAsset.loading,
    error: state.typeAsset.error,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onStoreTypeAsset: (data, token) => dispatch(actions.storeTypeAsset(data, token)),
    onClearErrorTypeAsset: () => dispatch(actions.clearErrorTypeAsset())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddTypeAsset);